<template>
  <v-card>
    <v-toolbar>
      <v-btn
        class="mr-3"
        title="Back to Standardizer Home"
        @click="$router.push('/hazard')"
        v-b-tooltip
        aria-label="Back to Standardizer Home"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>

      <v-text-field
        v-if="items && items.length"
        v-model="search"
        append-icon="mdi-magnify"
        hide-details
        label="Search in any field"
        single-line
        style="max-width: 15em"
      />

      <v-spacer />

      <v-switch
        v-if="items && items.length"
        v-model="selectable"
        class="mt-5 mr-4"
        label="Select"
      />

      <v-btn-toggle dense>
        <DeleteDialog
          v-model="visibleDelete"
          :disabled="!selected.length"
          :items="selected"
          :visible="selectable"
          button-title="mdi-delete"
          :api-url="HAZARD_URL"
          object-type="protocols"
          title="Delete selected protocols"
          @click="deleteItems(selected)"
          @itemDeleted="removeItems"
        />
      </v-btn-toggle>
    </v-toolbar>

    <v-data-table
      v-model="selected"
      :footer-props="{
        showFirstLastPage: true,
        itemsPerPageOptions: [10, 30, 50, -1],
      }"
      :hide-default-footer="items.length <= 10"
      :headers="headers"
      :items="items"
      :search="search"
      :items-per-page="50"
      :show-select="selectable"
      item-key="id"
    >
      <template #[`item.name`]="{ item }">
        <b-link :to="`/hazard/reports/${item.id}`">
          {{ item.name }}
        </b-link>
      </template>

      <template #[`item.dateCreated`]="{ item }">
        {{ dateTimeFormat.format(item.dateCreated) }}
      </template>

      <template
        v-if="!selectable"
        #[`item.actions`]="{ item }"
      >
        <v-icon
          title="Delete"
          @click="deleteItems([item])"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { dateFromObjectId, HAZARD_URL } from '@/main'
import DeleteDialog from '../dialogs/DeleteDialog.vue'
import { mapGetters } from 'vuex'

export default {
  components: { DeleteDialog },

  data: () => ({
    dateTimeFormat: new Intl.DateTimeFormat('en-US', {
      dateStyle: 'short',
      timeStyle: 'short',
    }),
    search: null,
    headers: [
      { text: 'Name', value: 'name' },
      {
        text: 'Date Created',
        value: 'dateCreated',
        sortable: false,
        filterable: false,
      },
      {
        text: 'Actions',
        value: 'actions',
        sortable: false,
        filterable: false,
        align: 'end',
      },
    ],
    items: [],
    visibleDelete: false,
    selected: [],
    selectable: false,
  }),

  computed: {
    ...mapGetters(['isAdmin']),
    HAZARD_URL() {
      return HAZARD_URL
    },
  },

  methods: {
    deleteItems(items) {
      this.selected = items
      this.visibleDelete = true
    },
    removeItems(items) {
      if (!Array.isArray(items)) this.items.splice(this.items.indexOf(items), 1)
      else items.forEach((item) => this.items.splice(this.items.indexOf(item), 1))
    },
    getData() {
      this.$axios.get(`${HAZARD_URL}/reports`).then((response) => {
        response.data.forEach((s) => (s.dateCreated = dateFromObjectId(s.id)))
        this.items = response.data
      })
    },
  },

  created() {
    this.getData()
  },
}
</script>
